import React from "react"

import Card from "react-bootstrap/Card"
import { useIntl } from "react-intl"

import Layout from "../components/layout"
import SEO from "../components/seo"
import SupportNavigation from "../components/support_navigation"
import CardDeck from "../components/card_deck"
import FormattedMarkdown from "../components/formatted_markdown"

import iconfinder_46_3319595 from "../images/iconfinder_46_3319595.png"

const SupportPage = ({ location }) => {
  const intl = useIntl()
  const pageTitle = intl.formatMessage({ id: "Support" })
  return (
    <Layout pageTitle={pageTitle} location={location}>
      <SEO title={pageTitle} />
      <SupportNavigation location={location} />
      <CardDeck>
        <SupportCard id="Support" img={iconfinder_46_3319595} />
        <Card style={{ visibility: "hidden" }} />
        <Card style={{ visibility: "hidden" }} />
      </CardDeck>
    </Layout>
  )
}

const SupportCard = props => {
  const intl = useIntl()
  return (
    <Card>
      <Card.Img src={props.img} />
      <Card.Body>
        <Card.Title>{intl.formatMessage({ id: props.id })}</Card.Title>
        <Card.Text>
          <FormattedMarkdown id={"Support." + props.id} />
        </Card.Text>
      </Card.Body>
    </Card>
  )
}

export default SupportPage
